<style scoped>
.abs-col {
  overflow-y: auto;
  padding: 0;
  background-color: white;
  height: calc(100vh - 64px);
}

.abs-col:last-child {
  z-index: 1;
  box-shadow: 2px 3px 6px 0px black;
}

ul.collapsible {
  margin: 0;
  border: 0;
}

.collapsible-body {
  padding: 0;
}

.collapsible-body li {
  display: block;
  padding: 18px 24px;
}

.collapsible-body li:not(:last-child) {
  border-bottom: 1px solid lightgray;
}
.itmsjobs {
  display: grid;
}
.itmsjobs > li {
  padding: 10px 20px;
  border-bottom: 1px solid #e0e0e0;
}
.itmsjobs > li.waves-effect.active {
    background: #b03236;
    color: white !important;
}
.itmsjobs > li.waves-effect.active p{
    color: white !important;
}
</style>

<template lang="pug">
    .main-content-nopad
      .row.nomargin
        .abs-col.col.l3.m4.s12
          ul.collapsible(ref='collapsibleJobs')
            li
              .collapsible-header.active Delivery Jobs
                span.badge {{deliveryJobs.length}}
              div
                ul.itmsjobs(v-if='deliveryJobs.length > 0')
                  li.waves-effect(v-for='(job, index) in sortLatest', :class="{ 'active': activeIndex === index }" ,  @click='viewJob(job, index)')
                    p.title.small.no-margin {{job.deliveryJobReferenceNumber}}
                    //- p.subtitle.micro {{$utils.formatter.formatLongDateTime(job.createdAt)}} {{ job.createdAt | moment }}
                    p.subtitle.micro {{ job.createdAt | moment }}
                div.center-align(v-else)
                  .vspace.small
                  p.grey-text No items available
                  .vspace.small
        .abs-col.col.l9.m8
          app-job-details(:job='selectedJob', v-if='selectedJob', @orderUpdated='onOrderUpdated')

      vue-modal.hide-on-med-and-up(
        v-if='selectedJob'
        :class='{hide: !selectedJob}',
        :options='{fullscreen: true, padding: "none"}'
        @close='modalClose')
        component(:is='modalContent' v-bind='{job: selectedJob, }' @orderUpdated='onOrderUpdated')
</template>
<script>
/* eslint-disable no-undef */
import moment from "moment";
import AppJobDetails from "@/components/app-job-details";
import axios from "axios";
import VueModal from "vue-modal";

export default {
  meta: {
    title: "Deliveries"
  },
  data() {
    return {
      deliveryJobs: [],
      selectedJob: null,
      modalContent: AppJobDetails,
      jobRefreshInterval: null,
      activeIndex: ''
    };
  },
  created() {
    this.getDeliveryJobs();
    if (this.$route.params.referenceNumber) {
      this.getSelectedJobByReferenceNumber();
    }
  },
  mounted() {
    this.$M.Collapsible.init(this.$refs.collapsibleJobs);
    this.jobRefreshInterval = setInterval(this.getDeliveryJobs, 60000);
  },
  destroyed() {
    clearInterval(this.jobRefreshInterval);
  },
  computed: {
    sortedOrders() {
      return this.orders.sort(this.orderSortFunction);
    },
    sortedOrderItems() {
      return this.orderItems.sort(this.orderItemSortFunction);
    },
    sortLatest() {
      return this.deliveryJobs.sort((a, b) =>
        b.createdAt.localeCompare(a.createdAt)
      );
    }
  },
  watch: {
    "$route.params"() {
      this.getSelectedJobByReferenceNumber();
    }
  },
  methods: {
    moment() {
      return moment();
    },
    orderSortFunction(orderA, orderB) {
      const fieldA = orderA["referenceNumber"];
      const fieldB = orderB["referenceNumber"];

      let result = 0;
      result =
        fieldA.toLowerCase() < fieldB.toLowerCase()
          ? -1
          : fieldA.toLowerCase() === fieldB.toLowerCase()
          ? 0
          : 1;

      return this.toggleSort ? result * -1 : result;
    },
    orderItemSortFunction(orderItemA, orderItemB) {
      const fieldA = orderItemA["status"];
      const fieldB = orderItemB["status"];

      let result = 0;
      result =
        fieldA.toLowerCase() < fieldB.toLowerCase()
          ? -1
          : fieldA.toLowerCase() === fieldB.toLowerCase()
          ? 0
          : 1;

      return this.toggleSort ? result * -1 : result;
    },
    onOrderUpdated(order) {
      this.getSelectedJobByReferenceNumber(order.referenceNumber);
      this.getDeliveryJobs();
    },
    getDeliveryJobs() {
      this.$store.dispatch("auth/getAccessToken").then(accessToken => {
        axios
          .get(
            `${this.$config.API_URL}/admin/delivery-jobs?deliveredBy=inomph`,
            {
              headers: {
                Authorization: `Bearer ${accessToken}`
              }
            }
          )
          .then(result => {
            this.deliveryJobs = result.data;
            this.$store.commit(
              "config/setDeliveryJobsCount",
              result.data.length
            );
          });
      });
    },
    getSelectedJobByReferenceNumber() {
      if (!this.$route.params.referenceNumber) {
        this.selectedJob = null;
        return;
      }

      this.$store.dispatch("auth/getAccessToken").then(accessToken => {
        return axios
          .get(
            `${this.$config.API_URL}/admin/delivery-jobs/${
              this.$route.params.referenceNumber
            }`,
            {
              headers: {
                Authorization: "Bearer " + accessToken
              }
            }
          )
          .then(result => {
            this.selectedJob = result.data;
          });
      });
    },
    showOrderDetails(index) {
      this.order = this.orders[index];
      this.orderIndex = index;

      axios
        .get(
          `${this.$config.API_URL}/admin/orders?referenceNumber=` +
            this.order.referenceNumber +
            `&deep=true&deliveredBy=Inomph&status=In-Transit`
        )
        .then(result => {
          this.orderItems = result.data[0].orderItems;
        });
    },
    viewJob(job, i) {
      this.activeIndex = i
      this.$router.push({
        name: "deliveryJobsByReference",
        params: { referenceNumber: job.deliveryJobReferenceNumber }
      });
    },
    modalClose() {
      this.selectedJob = null;
      this.$router.back();
    }
  },
  filters: {
    moment(date) {
      return moment(date).format("MMMM Do YYYY, h:mm:ss a");
    }
  },
  components: {
    AppJobDetails,
    VueModal
  }
};
</script>



// WEBPACK FOOTER //
// src/components/page-delivery-jobs.vue